function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 491.001 491.001"
      fill="none"
      {...props}
    >
      <path
        d="M470.3,337.05h-52.1v-93.8c0-11.5-9.4-20.9-20.9-20.9H265.9v-69.9H317c11.5,0,19.8-8.3,20.9-19.8V21.25
        c0-11.5-9.4-20.9-20.9-20.9H173.1c-11.5,0-20.9,9.4-20.9,20.9v110.5c0,11.5,9.4,20.9,20.9,20.9h51.1v69.9H91.8
        c-11.5,0-20.9,9.4-20.9,20.9v93.8h-50c-11.5,0-20.9,9.4-20.9,20.9v111.6c0,11.5,9.4,20.9,20.9,20.9h142.8
        c11.5,0,20.9-9.4,21.9-20.9v-111.8c0-11.5-9.4-20.9-20.9-20.9h-52.1v-74h264.8v74h-51.1c-11.5,0-20.9,9.4-20.9,20.9v111.6
        c0,11.5,9.4,20.9,20.9,20.9h142.8c11.5,0,20.9-9.4,21.9-20.9v-111.6C491.1,346.45,481.7,337.05,470.3,337.05z M194,41.05h103.2
        v70.9H194V41.05z M144,449.65H40.7v-70.9h103.2v70.9H144z M449.4,449.65H346.2v-70.9h103.2V449.65z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgComponent;
